<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useShowAllItems } from '@/composables/use-show-all-items'
import { LibraryCard } from '@/ui/common/library/library-card'
import TextView from '@/ui/common/text-view/TextView.vue'
import { IAgent } from '@/api/modules/task-library/types'

const DEFAULT_ITEMS_TO_SHOW_LIBRARY = 3

interface Props {
  items: IAgent[]
  hasMore: boolean
}

interface Emits {
  (e: 'showmore'): void
}

const emit = defineEmits<Emits>()
const props = defineProps<Props>()

const showmore = async () => {
  emit('showmore')
}
</script>

<template>
  <div class="LibraryCardGroup">
    <div class="LibraryCardGroup__cardsWrapper">
      <LibraryCard
        v-for="{ name, description, agent_id, status } in props.items"
        :key="agent_id"
        :additional-text-overflow="description"
        :main-text-overflow="name"
        :agent-id="agent_id"
        :status="status"
      />
    </div>
    <a-button v-if="hasMore" @click="showmore" class="LibraryCardGroup__button">
      <TextView variant="roboto_13_medium"> Посмотреть все </TextView>
    </a-button>
  </div>
</template>

<style lang="css" scoped>
.LibraryCardGroup__cardsWrapper {
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}

.LibraryCardGroup__button {
  border: initial;
  box-shadow: initial;
  width: 100%;
  background-color: var(--gray_20);
}

@media (max-width: 767px) {
  .LibraryCardGroup__cardsWrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}
</style>
